import { useEffect, useState } from "react";
import { View } from "react-native";

function Waveform({
  recording,
  hasSelectedFile,
}: {
  recording: boolean;
  hasSelectedFile: boolean;
}) {
  const [levels, setLevels] = useState<number[]>([]);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    if (recording && !hasSelectedFile) {
      interval = setInterval(() => {
        setLevels((prev) => {
          const newLevels = [...prev, Math.random() * 42 + 11]; // 11 to 53
          return newLevels.slice(-20); // keep last 20 bars
        });
      }, 100);
    } else if (hasSelectedFile) {
      setLevels([...Array.from({ length: 20 }, () => Math.random() * 42 + 11)]);
    } else {
      setLevels([...Array.from({ length: 20 }, () => 11)]);
    }

    return () => clearInterval(interval);
  }, [recording, hasSelectedFile]);

  return (
    <View style={{ flexDirection: "row", alignItems: "flex-end", height: 60 }}>
      {levels.map((h, i) => (
        <View
          key={i}
          style={{
            width: 3,
            height: h,
            marginHorizontal: 4, // gap of 8 (4px on each side)
            borderRadius: 2,
          }}
          className="bg-teachLoop-accentPrimaryDisabled"
        />
      ))}
    </View>
  );
}

export default Waveform;
